import { Injectable } from '@angular/core';
import { BasicService } from '../../../../services/basic.service';

@Injectable()
export class NewHscModalV1Service {
  private baseUrl = 'http://127.0.0.1:38088';

  constructor(private baseService: BasicService) {}

  // 打开摄像头
  openCamera(camidx: number = 0) {
    return `${this.baseUrl}/video=stream?camidx=${camidx}&t=${Date.now()}`;
  }

  // 关闭摄像头
  closeCamera(camidx: number = 0) {
    const body = { camidx: String(camidx) };
    this.baseService
      .post({
        url: `${this.baseUrl}/video=close`,
        body,
      })
      .subscribe();
  }

  // 旋转摄像头
  rotate(degree: number, camidx: number = 0) {
    const body = { camidx: String(camidx), rotate: String(degree) };
    this.baseService
      .post({
        url: `${this.baseUrl}/video=rotate`,
        body,
      })
      .subscribe();
  }

  // 开启/关闭纠偏
  deskew(enabled: boolean, camidx: number = 0) {
    const body = {
      camidx: String(camidx),
      open: enabled ? '1' : '0',
    };
    this.baseService
      .post({
        url: `${this.baseUrl}/dvideo=cameradeskew`,
        body,
      })
      .subscribe();
  }

  // 摄像头拍照，返回图片 base64
  scan(camidx: number = 0, deskew: number = 0): Promise<string> {
    const body = {
      filepath: 'base64',
      rotate: '0',
      cutpage: '0',
      ColorMode: '0',
      quality: '3',
      camidx: String(camidx),
      deskew: String(deskew),
    };
    return new Promise((resolve, reject) => {
      this.baseService
        .post({
          url: `${this.baseUrl}/video=grabimage`,
          body,
        })
        .subscribe(
          (res: any) => {
            resolve(`data:image/jpg;base64,${res.photoBase64}`);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  // 获取设备连接数
  getDeviceConnect(): Promise<number> {
    return new Promise((resolve) => {
      this.baseService
        .post({
          url: `${this.baseUrl}/device=isconnect`,
        })
        .subscribe(
          (res: any) => {
            resolve(res.data as number);
          },
          (error) => {
            resolve(0);
          }
        );
    });
  }

  // 获取设备状态
  getDeviceStatus(): Promise<{ video0: string; video1: string; video2: string }> {
    return new Promise((resolve, reject) => {
      this.baseService
        .post({
          url: `${this.baseUrl}/video=status`,
        })
        .subscribe(
          (res: any) => {
            resolve({
              video0: res.video0,
              video1: res.video1,
              video2: res.video2,
            });
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  // 获取设备型号
  getEquipmentType(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.baseService
        .post({
          url: `${this.baseUrl}/device=getequipmenttype`,
        })
        .subscribe(
          (res: any) => {
            resolve(res.data as string);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  // 获取设备序列号
  getSerialNumber(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.baseService
        .post({
          url: `${this.baseUrl}/device=getsonixserialnumber`,
        })
        .subscribe(
          (res: any) => {
            resolve(res.data as string);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }
}
